import React from 'react'
import { STEPS } from './useReservation'
import ThumbsUp from '@assets/img/reservation/thumbs-up.svg'
import { useReservationContext } from './ReservationContext'
import Loader from '../search-trip/components/Loader'

const Footer = ({
    headingText,
    subheaderText,
    offer,
    reservationLoading,
    paymentMethod,
    currentStep,
    onClick,
    paymentDisabled = false,
}) => {
    const { loading, handleSubmit, selectedInsurance, selectedParkingOffer, getReservationTotalPrice, t } = useReservationContext()

    return (
        <div className="trip-reservation__section">
            <div className="trip-reservation__section-headings">
                <div className="trip-reservation__section-content-icon-box">
                    <img src={ThumbsUp} alt="thumb-up" />
                </div>
                <div className="trip-reservation__section-heading">{headingText}</div>
                <div className="trip-reservation__section-subheader">{subheaderText}</div>
                {currentStep === STEPS.PAYMENT ? (
                    <div className="trip-reservation__section-summary">
                        <div className="trip-reservation__section-summary-left">
                            <div className="trip-reservation__section-summary-text">{t('amount-to-pay')}:</div>
                            <div className="trip-reservation__section-summary-price">
                                {getReservationTotalPrice(true)} PLN
                            </div>
                         </div>
                        {reservationLoading ? (
                            <Loader />
                        ) : (
                            <>
                                {paymentMethod ? (
                                    <button
                                        onClick={handleSubmit}
                                        disabled={
                                            paymentDisabled ||
                                            !paymentMethod ||
                                            reservationLoading
                                        }
                                        className={`trip-reservation__btn trip-reservation__btn--summary ${
                                            paymentDisabled || !paymentMethod
                                                ? 'trip-reservation__btn-disabled'
                                                : ''
                                        }`}
                                    >
                                        {t('pay-now')}
                                    </button>
                                ) : null}
                            </>
                        )}
                    </div>
                ) : (
                    <button
                        className={`trip-reservation__btn trip-reservation__btn--footer ${
                            reservationLoading ? 'trip-reservation__btn-disabled' : ''
                        }`}
                        type="button"
                        disabled={reservationLoading || loading}
                        onClick={onClick}
                    >
                        {currentStep === STEPS.INSURANCE && selectedInsurance === null
                            ? t('continue-without-insurance')
                            : t('continue')}
                    </button>
                )}
            </div>
        </div>
    )
}

export default Footer
